<div modalHeader class="modal-header py-2">
  <h2 class="mb-0">{{ title | titlecase }}</h2>
  <tr-icon [icon]="icon.cancel" classes="ml-auto py-1 px-2" (click)="cancel()"></tr-icon>
</div>

<div modalContent class="modal-body">
  <form [formGroup]="customerForm" novalidate role="form">
    <div class="row">
      <div class="form-group col-xs-12 col-sm-6">
        <label for="settings-username" class="control-label ">Name</label>
        <input
          id="settings-username"
          type="username"
          class="form-control"
          formControlName="name"
          [class.is-invalid]="validateField('name')"
        />
        <control-messages [control]="customerForm.get('name')"></control-messages>
      </div>
      <div class="form-group col-xs-12 col-sm-6">
        <label for="new-rest-phone" class="control-label">Phone</label>
        <input
          id="new-rest-phone"
          type="tel"
          class="form-control"
          data-dd-privacy="mask"
          formControlName="phone"
          [value]="customerForm.controls.phone.value | trTel: settings.country"
          [class.is-invalid]="customerForm.get('phone').invalid && customerForm.get('phone').touched"
        />
        <control-messages [control]="customerForm.get('phone')"></control-messages>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-xs-12 col-sm-6">
        <label for="settings-email" class="control-label">Email</label>
        <input
          id="settings-email"
          type="email"
          class="form-control"
          data-dd-privacy="mask"
          formControlName="email"
          [class.is-invalid]="validateField('email')"
        />
        <control-messages [control]="customerForm.get('email')"></control-messages>
      </div>
      <div class="form-group col-xs-12 col-sm-6">
        <label for="input-modal-bday" class="control-label">Birthday</label>
        <div id="input-modal-bday" class="d-flex flex-row flex-nowrap">
          <select class="form-control mr-1" id="month" formControlName="birthdayMonth" (ngModelChange)="generateDaysOfMonth()">
            <option [value]="null" [disabled]="true">MM</option>
            <option *ngFor="let month of monthsRange" [value]="month" data-dd-privacy="mask">{{ month }}</option>
          </select>
          <select class="form-control mr-1" id="day" formControlName="birthdayDay">
            <option [value]="null" [disabled]="true">DD</option>
            <option *ngFor="let day of daysRange" [value]="day" data-dd-privacy="mask">{{ day }}</option>
          </select>
          <select class="form-control" id="year" formControlName="birthdayYear">
            <option [value]="null" [disabled]="true">YY</option>
            <option *ngFor="let year of yearsRange" [value]="year" data-dd-privacy="mask">{{ year }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class=" form-group">
      <label for="settings-user-fullname" class="control-label">Address</label>
      <div class="">
        <input
          id="settings-user-fullname"
          type="text"
          class="form-control"
          formControlName="address"
          [class.is-invalid]="validateField('address')" data-dd-privacy="mask"
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-xs-12 col-sm-4">
        <label for="input-modal-city" class="control-label">City</label>
        <input type="text" class="form-control" formControlName="city" id="input-modal-city" data-dd-privacy="mask" />
      </div>
      <div class="form-group col-xs-12 col-sm-4">
        <label for="input-modal-state" class="control-label">{{ stateLabelText }}</label>
        <input type="text" class="form-control" formControlName="state" id="input-modal-state" data-dd-privacy="mask" />
      </div>
      <div class="form-group col-xs-12 col-sm-4">
        <label for="input-modal-zip" class="control-label">{{ zipLabelText }}</label>
        <input type="text" class="form-control" formControlName="zip" id="input-modal-zip" data-dd-privacy="mask" />
      </div>
    </div>
    <div class="form-group">
      <label for="input-modal-note" class="control-label">Notes</label>
      <textarea
        class="form-control"
        id="input-modal-note"
        rows="3"
        maxlength="160"
        formControlName="note"
      ></textarea>
    </div>
    <ng-container *ngIf="!isOnFreePlan">
      <tablesready-customer-custom-fields
        id="customFields"
        formControlName="customFields"
        [config]="settings.customFields"
        [country]="settings.country"
      ></tablesready-customer-custom-fields>
    </ng-container>
  </form>
</div>

<div modalFooter class="modal-footer">
  <button class="btn btn-info mr-2" type="submit" (click)="save()" [disabled]="customerForm.invalid"
          angulartics2On="click"
          angularticsAction="Confirm Add/Edit Customer"
          angularticsCategory="customer" >Confirm</button>
  <button type="button" class="btn btn-danger" (click)="cancel()"
          angulartics2On="click"
          angularticsAction="Cancel Add/Edit Customer"
          angularticsCategory="customer" >Cancel</button>
</div>
